var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sign-in-wrap mds-layout-grid" }, [
    _c("span", {
      staticStyle: { display: "none" },
      domProps: {
        innerHTML: _vm._s(
          require("!svg-inline-loader!../../../node_modules/morningstar-design-system/dist/mds.svg")
        )
      }
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mds-layout-grid__col" },
      [
        _c("login-form", {
          class: {
            "is-rtl-language-type": this.$mwc.labeller.languageId === "ar"
          },
          attrs: {
            isEmail: this.settings.useEmail,
            logoUrl: this.settings.logoUrl,
            errorText: this.settings.errorText,
            resetPasswordUrl: this.settings.resetPasswordUrl
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }